import { render, staticRenderFns } from "./CustomerSelectCmp.vue?vue&type=template&id=56eea2e9&scoped=true"
import script from "./CustomerSelectCmp.vue?vue&type=script&lang=js"
export * from "./CustomerSelectCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eea2e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56eea2e9')) {
      api.createRecord('56eea2e9', component.options)
    } else {
      api.reload('56eea2e9', component.options)
    }
    module.hot.accept("./CustomerSelectCmp.vue?vue&type=template&id=56eea2e9&scoped=true", function () {
      api.rerender('56eea2e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerSelectCmp/CustomerSelectCmp.vue"
export default component.exports